/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantDto } from '../../models/backend-opex-variant-dto';
import { BackendPatchedOpexVariantRequestDto } from '../../models/backend-patched-opex-variant-request-dto';

export interface OpexesVariantsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedOpexVariantRequestDto;
}

export function opexesVariantsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesVariantsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, opexesVariantsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexVariantDto>;
    }),
  );
}

opexesVariantsPartialUpdate.PATH = '/api/opexes/variants/{id}/';
